/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageProficiency } from '../../models/language-proficiency';

export interface GetLanguageProficiencies$Params {
  profileId: string;
}

export function getLanguageProficiencies(http: HttpClient, rootUrl: string, params: GetLanguageProficiencies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageProficiency>>> {
  const rb = new RequestBuilder(rootUrl, getLanguageProficiencies.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LanguageProficiency>>;
    })
  );
}

getLanguageProficiencies.PATH = '/studentprofile/{profileId}/languageproficiency';
